//@flow
import React from 'react';
import {makeStyles, Typography, Tooltip} from '@material-ui/core';
import {InfoOutlined} from '@material-ui/icons';

const useStyles = makeStyles(theme => ({
  tooltip: {
    marginLeft: theme.spacing(2),
    backgroundColor: '#F4F4F6',
    borderRadius: '8px',
    textAlign: 'center',
    maxWidth: 240,
  },
  textTooltip: {
    textAlign: 'left!important',
    color: ' #717190',
    fontSize: '10px',
    '& span': {
      marginLeft: theme.spacing(1),
    },
  },
  infoBtn: {
    color: '#9595AB',
  },
}));

export default function ProductVideoTooltip() {
  const classes = useStyles();

  return (
    <Tooltip
      placement="right"
      enterTouchDelay={0}
      classes={{tooltip: classes.tooltip}}
      title={
        <Typography className={classes.textTooltip}>
          Puedes subir videos de Youtube o Tik Tok.
          <br />
          Paso 1: Ingresa a tu video <br />
          Paso 2: <br />
          {/* <span>
        Instagram: Click en los <b>...</b> y en <b>Insertar</b> <br />
      </span> */}
          <span>
            Tik Tok: Click en <b>Compartir</b> - <b>Insertar</b> <br />
          </span>
          <span>
            Youtube: Click en <b>Compartir</b> - <b>Incorporar</b> <br />
          </span>
          Paso 3: Copiar enlace aquí
        </Typography>
      }
    >
      <InfoOutlined color="primary" className={classes.infoBtn} />
    </Tooltip>
  );
}
